import { NextPage } from 'next';
import { getDataFromTree } from '@apollo/client/react/ssr';
// Hocks
import withApollo from 'hocs/withApollo';
// Helpers
import { getEnvLink } from 'helpers/routes';
import { generateHomeStructuredData } from 'helpers/structured-data';
// Layouts
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
// Components
import HomePage from 'components/HomePage/components/V3/HomePage';

const Home: NextPage = () => {
  const image = `${getEnvLink()}${'/homepage.jpg'}`;

  return (
    <>
      <Head
        image={image}
        title="MILLIONS: Sports Streaming, Ecommerce and Influencer Marketing"
        description="MILLIONS is a sports streaming and ecommerce platform for athletes, fans, and brands. Watch live events, shop merch, and join the sports community."
        structuredData={generateHomeStructuredData()}
      />
      <Header />
      <HomePage />
    </>
  );
};

export default withApollo(Home, { getDataFromTree });
